module.exports = __webpack_public_path__ + "img/activity1.f4f7b751.png";